import type * as React from 'react';

function SvgFilterSliders(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M3 7H5.1843C5.0722 6.6857 5 6.3524 5 6C5 5.6476 5.0723 5.3143 5.1843 5H3C2.4473 5 2 5.4478 2 6C2 6.5522 2.4473 7 3 7Z"
        fill="currentColor"
      />
      <path
        d="M21 7C21.5527 7 22 6.5522 22 6C22 5.4478 21.5527 5 21 5H10.8157C10.9278 5.3143 11 5.6476 11 6C11 6.3524 10.9277 6.6857 10.8157 7H21Z"
        fill="currentColor"
      />
      <path
        d="M3 13H13.1843C13.0722 12.6857 13 12.3524 13 12C13 11.6476 13.0723 11.3143 13.1843 11H3C2.4473 11 2 11.4478 2 12C2 12.5522 2.4473 13 3 13Z"
        fill="currentColor"
      />
      <path
        d="M21 11H18.8157C18.9278 11.3143 19 11.6476 19 12C19 12.3524 18.9277 12.6857 18.8157 13H21C21.5527 13 22 12.5522 22 12C22 11.4478 21.5527 11 21 11Z"
        fill="currentColor"
      />
      <path
        d="M21 17H10.8157C10.9278 17.3143 11 17.6476 11 18C11 18.3524 10.9277 18.6857 10.8157 19H21C21.5527 19 22 18.5522 22 18C22 17.4478 21.5527 17 21 17Z"
        fill="currentColor"
      />
      <path
        d="M3 17C2.4473 17 2 17.4478 2 18C2 18.5522 2.4473 19 3 19H5.1843C5.0722 18.6857 5 18.3524 5 18C5 17.6476 5.0723 17.3143 5.1843 17H3Z"
        fill="currentColor"
      />
      <path
        d="M8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8Z"
        fill="currentColor"
      />
      <path
        d="M16 14C17.1046 14 18 13.1046 18 12C18 10.8954 17.1046 10 16 10C14.8954 10 14 10.8954 14 12C14 13.1046 14.8954 14 16 14Z"
        fill="currentColor"
      />
      <path
        d="M8 20C9.10457 20 10 19.1046 10 18C10 16.8954 9.10457 16 8 16C6.89543 16 6 16.8954 6 18C6 19.1046 6.89543 20 8 20Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgFilterSliders;
